<template>
    <div class="nav" :class="smallMargin ? 'mb-4' : 'mb-8'">
        <ul id="cart-navigation" ref="navigation" class="flex-level m-0">
            <li>
                <router-link
                    v-slot="{ navigate, isActive }"
                    :to="{
                        name:
                            context === 'client'
                                ? 'sam.v4.client.form.plan'
                                : `sam.v4.client.${context}.form.plan`,
                        params: { id: $route.params.id },
                    }"
                    custom
                >
                    <button
                        ref="plan-link"
                        class="semibold white-bkg b-0 p-0 pb-2 fs-3 cpointer"
                        :class="{ 'primary-50': isActive }"
                        @click="navigate"
                    >
                        {{ $l10n.__('Choisir un plan') }}
                    </button>
                </router-link>
            </li>
            <li class="ml-4">
                <router-link
                    v-slot="{ navigate, isActive }"
                    :to="{
                        name:
                            context === 'client'
                                ? 'sam.v4.client.form.configuration'
                                : `sam.v4.client.${context}.form.configuration`,
                        params: { id: $route.params.id },
                    }"
                    custom
                >
                    <button
                        ref="config-link"
                        class="semibold white-bkg b-0 p-0 pb-2 cpointer fs-3"
                        :class="{ 'primary-50': isActive }"
                        @click="navigate"
                    >
                        {{ $l10n.__('Configuration') }}
                    </button>
                </router-link>
            </li>
            <li v-if="isSourceSale && !isLatestPricingVersion && context === 'renew'" class="ml-4">
                <router-link
                    v-slot="{ navigate, isActive }"
                    :to="{
                        name: 'sam.v4.client.renew.form.licences',
                        params: { id: $route.params.id },
                    }"
                    custom
                >
                    <button
                        ref="licence-link"
                        data-testid="licence-link"
                        class="semibold white-bkg b-0 p-0 pb-2 cpointer fs-3"
                        :class="{ 'primary-50': isActive }"
                        @click="navigate"
                    >
                        {{ $l10n.__('Gestion des licences') }}
                    </button>
                </router-link>
            </li>
            <li class="ml-4">
                <router-link
                    v-slot="{ navigate, isActive }"
                    :to="{
                        name:
                            context === 'client'
                                ? 'sam.v4.client.form.payment'
                                : `sam.v4.client.${context}.form.payment`,
                        params: { id: $route.params.id },
                    }"
                    custom
                >
                    <button
                        ref="pay-link"
                        data-testid="pay-link"
                        class="semibold white-bkg b-0 p-0 pb-2 fs-3"
                        :class="{
                            cpointer: canGoToPayment,
                            cnotallowed: !canGoToPayment,
                            'primary-50': isActive,
                        }"
                        :disabled="!canGoToPayment"
                        @click="navigate"
                    >
                        {{ $l10n.__('Paiement') }}
                    </button>
                </router-link>
            </li>
        </ul>
        <div
            class="selected-underline primary-50-bkg"
            :style="{ left: underlineOffset + 'px', width: underlineWidth + 'px' }"
        />
    </div>
</template>

<script>
export default {
    props: {
        smallMargin: {
            type: Boolean,
            required: true,
        },
        context: {
            type: String,
            required: true,
            validator: (value) => ['upsell', 'renew', 'client'].includes(value),
        },
    },
    data() {
        return {
            underlineOffset: 0,
            underlineWidth: 0,
        };
    },
    computed: {
        isSourceSale() {
            return this.$store.getters[`${this.context}Cart/isSourceSale`];
        },
        isLatestPricingVersion() {
            return this.$store.getters[`${this.context}Cart/isLatestPricingVersion`];
        },
        canGoToPayment() {
            return this.$store.getters[`${this.context}Cart/canGoToPayment`];
        },
    },
    watch: {
        $route(to) {
            this.updateUnderlineByRoute(Array.from(this.$refs.navigation?.children), to.name);
        },
    },
    mounted() {
        const interval = setInterval(() => {
            if (this.$refs.navigation && this.$refs.navigation.children.length > 1) {
                this.updateUnderlineByRoute(
                    Array.from(this.$refs.navigation.children),
                    this.$route.name,
                );
                clearInterval(interval);
            }
        }, 100);
    },
    methods: {
        updateUnderlineByRoute(children, activeRoute) {
            let firstActiveChild;

            switch (activeRoute) {
                case 'sam.v4.client.form.plan':
                case `sam.v4.client.${this.context}.form.plan`:
                    firstActiveChild = children[0];
                    break;
                case 'sam.v4.client.form.configuration':
                case `sam.v4.client.${this.context}.form.configuration`:
                    firstActiveChild = children[1];
                    break;
                case `sam.v4.client.${this.context}.form.licences`:
                    firstActiveChild = children[2];
                    break;
                case 'sam.v4.client.form.payment':
                case `sam.v4.client.${this.context}.form.payment`:
                    firstActiveChild =
                        this.context === 'renew' && !this.isLatestPricingVersion
                            ? children[3]
                            : children[2];
                    break;
                default:
                    firstActiveChild = children[0];
            }

            this.underlineOffset = firstActiveChild.offsetLeft;
            this.underlineWidth = firstActiveChild.offsetWidth;
        },
    },
};
</script>

<style lang="scss" scoped>
.nav {
    overflow: hidden;
    position: relative;
    width: fit-content;
    &:before {
        content: '';
        background: var(--colors-common-background-default);
        bottom: 0;
        height: 1px;
        left: 0;
        position: absolute;
        width: 100%;
        z-index: 1;
    }

    .selected-underline {
        bottom: 0;
        height: 2px;
        position: absolute;
        transition: 0.33s all ease-in-out;
        z-index: 1;
    }
}
</style>
